import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { personsService } from "../services/persons.service";
import type { ListPersonsParams, PersonCreateRequest, PersonUpdateRequest } from "../types";

const QUERY_KEY = "persons";

export function usePersonsList(params: ListPersonsParams) {
	return useQuery({
		queryKey: [QUERY_KEY, params],
		queryFn: () => personsService.list(params),
		placeholderData: (previous) => previous,
	});
}

export function useCreatePerson() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (data: PersonCreateRequest) => personsService.create(data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Shaxs qo'shildi");
		},
		onError: () => {
			message.error("Shaxsni qo'shib bo'lmadi");
		},
	});
}

export function useUpdatePerson() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: ({ id, data }: { id: string; data: PersonUpdateRequest }) =>
			personsService.update(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Shaxs saqlandi");
		},
		onError: () => {
			message.error("Shaxsni saqlab bo'lmadi");
		},
	});
}

export function useDeletePerson() {
	const queryClient = useQueryClient();
	const { message } = App.useApp();

	return useMutation({
		mutationFn: (id: string) => personsService.remove(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [QUERY_KEY] });
			message.success("Shaxs o'chirildi");
		},
		onError: () => {
			message.error("Shaxsni o'chirib bo'lmadi");
		},
	});
}
